<template>
  <div id="pageContent">
    <div class="my-page">
      <ul class="top-info">
        <!-- 현재 메뉴 위치 및 -->
        <li class="logo-img" :class="{isDisplay: isDisplayNone && !pwdCheck}">
          <img src="@/assets/img/dragons_logo.png" alt="dragons_logo">
        </li>
        <li class="logo-text">
          <img src="@/assets/img/logo_text.png" alt="logo_text">
        </li>
      </ul>

      <div v-if="(currentMenu.includes('myInfo') || currentMenu.includes('withdraw')) && !pwdCheck">
        <PasswordInput @password="pwdCheckFunc" />
      </div>
      <div v-else>
        <router-view class="contents">

        </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordInput from '@/components/MyPage/PasswordInput.vue';

export default {
  name: 'MyPageView',
  components: {PasswordInput},
  data() {
    return {
      pwdCheck: false
    }
  },
  watch: {
    currentMenu: {
      handler: function () {
        this.pwdCheck = false;
      }
    }
  },
  mounted () {
  },
  methods: {
    pwdCheckFunc(data) {
      this.pwdCheck = data;
    }
  },
  computed: {
    isDisplayNone() {
      switch (this.$route.name) {
        case 'myInfo' :
          return true;
        case 'withdraw' :
          return true;
        default :
          return false;
      }
    },
    currentMenu() {
      return this.$route.name;
    }
  }
}
</script>
